/**
 * QualityOverview — at-a-glance house-style quality across the latest plan per
 * run: average score, pass count, and any plans currently flagged below
 * standard (so a model/prompt regression surfaces early).
 */
import React, { useEffect, useState } from "react";
import { Gauge, AlertTriangle, CheckCircle2 } from "lucide-react";
import api from "../../lib/api";

const tone = (s) => (s >= 90 ? "text-emerald-600" : s >= 70 ? "text-amber-600" : "text-red-600");

export default function QualityOverview() {
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/admin/assessments/quality-overview").then((r) => setD(r.data)).catch(() => {});
  }, []);

  if (!d || !d.total) return null;

  return (
    <div className="border border-zinc-200 bg-white p-4 mb-6" data-testid="quality-overview">
      <div className="flex items-center gap-2 mb-3">
        <Gauge size={15} className="text-[#7737F6]" />
        <span className="text-[11.5px] font-medium tracking-[0.14em] uppercase text-zinc-600">Output quality (house style)</span>
        <span className="text-[11px] text-zinc-400">latest plan across {d.total} run{d.total === 1 ? "" : "s"}</span>
      </div>
      <div className="flex flex-wrap items-center gap-6">
        <div>
          <div className={`text-3xl font-semibold ${tone(d.average_score)}`} data-testid="quality-avg">{d.average_score}<span className="text-base text-zinc-400">/100</span></div>
          <div className="text-[11px] text-zinc-500">average score</div>
        </div>
        <div className="flex items-center gap-2 text-[13px] text-emerald-700">
          <CheckCircle2 size={15} /> {d.passed} pass
        </div>
        <div className={`flex items-center gap-2 text-[13px] ${d.flagged ? "text-amber-700" : "text-zinc-400"}`} data-testid="quality-flagged-count">
          <AlertTriangle size={15} /> {d.flagged} flagged
        </div>
      </div>

      {d.flagged_runs?.length > 0 && (
        <div className="mt-3 border-t border-zinc-100 pt-3 space-y-1.5" data-testid="quality-flagged-list">
          {d.flagged_runs.map((r) => (
            <div key={r.run_id} className="flex items-center justify-between gap-3 text-[12px]" data-testid={`quality-flagged-${r.run_id}`}>
              <span className="text-zinc-700"><strong>{r.sub_brand}</strong> · {r.client}</span>
              <span className="flex items-center gap-3">
                <span className="text-zinc-400 hidden sm:inline">{r.violations.join(" · ")}</span>
                <span className={`font-semibold ${tone(r.score)}`}>{r.score}/100</span>
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
